// Unpublished Work © 2024 Deere & Company.
export const surchargeRenderToggleOn = (
  isUSDealer: boolean,
  isCanadaDealer: boolean,
  portlandSurchargeEnabled: boolean
) => (isUSDealer || isCanadaDealer) && portlandSurchargeEnabled;
